<template>
  <ValidationObserver v-slot="{handleSubmit, invalid, reset}" ref="observer">
    <artisio-modal :visible="modal.show"
                   :title="$t('Increments')"
                   @show="onShow"
                   @hidden="onHidden"
                   @ok.prevent="handleSubmit(onSubmit)"
                   :ok-title="$t('Submit')"
                   :is-loading="loading"
                   scrollable>
      <increment-tiers :model="model" attribute="increments"
                       v-if="sale && sale.increment_calculation_source === 'bid'"/>
      <input-widget :label="$t('Step')" :model="model.increments[0]" attribute="increment" type="number"
                    v-if="model && model.increments && model.increments.length && sale && sale.increment_calculation_source === 'reserve'"/>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "@/core/components/artisio-modal/ArtisioModal";
  import IncrementTiers from "@/core/components/increment-tiers/IncrementTiers";
  import Increment from "@/core/components/increment-tiers/Increment.model";
  import IncrementsModel from "@/core/components/increment-tiers/incrementsModel.model";
  import InputWidget from "@/core/components/input-widget/InputWidget.vue";
  import helperService from "@/core/services/helper.service";

  const {mapState, mapActions} = createNamespacedHelpers('reservations');

  export default {
    name: "LotIncrementsModal",
    components: {InputWidget, IncrementTiers, ArtisioModal},
    data: () => {
      return {
        loading: false,
        model: new IncrementsModel(),
      }
    },
    methods: {
      ...mapActions(['hideLotIncrementsModal', 'postLotIncrements']),
      async onSubmit() {
        let requestData = this.model.increments.map(increment => {
          return {...increment.toJSON(), lot_uuid: this.lot.uuid}
        });

        this.loading = true;
        let response = await this.postLotIncrements(requestData);
        this.loading = false;

        if (response.success) {
          this.$toast('success', this.$t('Increments were successfully saved'));
          await this.hideLotIncrementsModal();
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            for (let index in response.body) {
              this.model.increments[index].setMultipleErrors(response.body[index]);
            }
          }
        }
      },
      onShow() {
        this.initIncrements();
      },
      onHidden() {
        this.model = new IncrementsModel();
        this.hideLotIncrementsModal();
      },
      initIncrements() {
        if (this.sale.increment_calculation_source === 'reserve') {
          this.model = new IncrementsModel({
            increments: [new Increment({
              max: null,
              increment: helperService.getLotIncrementStep(this.lot, this.increments) || 1
            })]
          });
        } else {
          let increments = this.lot.increments;
          if (!increments.length) {
            increments = this.increments.map(data => {
              const obj = {
                ...data
              }
              delete obj['uuid']
              return obj;
            });
          }
          this.model = new IncrementsModel({increments: increments.map(data => new Increment(data))});
        }
      },
    },
    watch: {
      increments() {
        this.initIncrements();
      }
    },
    computed: {
      ...mapState({
        modal: state => state.view.lotIncrementsData.modal,
        sale: state => state.view.lotIncrementsData.modal.sale,
        increments: state => state.view.lotIncrementsData.modal.increments,
        lot: state => state.view.lotIncrementsData.modal.lot,
      }),
    },
  }
</script>

<style lang="scss" scoped>
</style>

